import { useContext, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { UserContext } from '../../../contexts/UserContext';
import { useOrganisationsQuery } from '../../../types/graphqlTypes';

// The attribute on <html> that hides Odoo's livechat bubble (loaded in index.html, hidden by index.css with it).
const HIDE_LIVECHAT_ATTRIBUTE = 'data-hide-livechat';

// The livechat reaches Pythagoras' support. Inside an organisation it shows only once the organisation is known
// to be one Pythagoras manages: one a partner manages gets its support from that partner. Outside an
// organisation (login, share links) it stays, for anyone looking for help.
export const LivechatLayout: React.FC2 = () => {
  const user = useContext(UserContext);
  const { organisationId = '' } = useParams();
  const { data } = useOrganisationsQuery({ variables: { includeIds: [organisationId] }, skip: !user || !organisationId });
  const organisation = data?.organisations.find((org) => org.id === organisationId);
  const managedByUs = !!organisation && !organisation.referral.managedBy;

  useEffect(() => {
    if (managedByUs) return undefined;
    document.documentElement.setAttribute(HIDE_LIVECHAT_ATTRIBUTE, '');
    return () => document.documentElement.removeAttribute(HIDE_LIVECHAT_ATTRIBUTE);
  }, [managedByUs]);

  return <Outlet />;
};
